const React = require("react");
const { Routes, Route, Navigate } = require("react-router-dom");
const { PrintifyProvider } = require("./context/PrintifyContext");
const { PrintifyLayout } = require("./components/PrintifyLayout");
const { SellerPrintifyDashboard } = require("./pages/SellerPrintifyDashboard");
const { SellerPrintifySettings } = require("./pages/SellerPrintifySettings");
const { SellerPrintifyConnection } = require("./pages/SellerPrintifyConnection");
const { DropshippingSuppliers } = require("./pages/DropshippingSuppliers");
const { DropshippingSupplierProducts } = require("./pages/DropshippingSupplierProducts");
const { SellerPrintifyProducts } = require("./pages/SellerPrintifyProducts");
const { SellerPrintifyProductDetails } = require("./pages/SellerPrintifyProductDetails");
const { DropshippingImportedProducts } = require("./pages/DropshippingImportedProducts");
const { SellerPrintifyOrders } = require("./pages/SellerPrintifyOrders");
const { DropshippingApiErrors } = require("./pages/DropshippingApiErrors");
const { DropshippingAdmin } = require("./pages/DropshippingAdmin");
const h = React.createElement;

const PrintifyRoutes = () => h(Routes, null,
  h(Route, { element: h(PrintifyLayout) },
    h(Route, { path: "printify", element: h(SellerPrintifyDashboard) }),
    h(Route, { path: "printify/settings", element: h(SellerPrintifySettings) }),
    h(Route, { path: "printify/details", element: h(SellerPrintifySettings) }),
    h(Route, { path: "printify/connect", element: h(SellerPrintifyConnection) }),
    h(Route, { path: "printify/connected", element: h(SellerPrintifyConnection) }),
    h(Route, { path: "printify/suppliers", element: h(DropshippingSuppliers) }),
    h(Route, { path: "printify/suppliers/:supplierId/products", element: h(DropshippingSupplierProducts) }),
    h(Route, { path: "printify/products", element: h(SellerPrintifyProducts) }),
    h(Route, { path: "printify/products/:productId", element: h(SellerPrintifyProductDetails) }),
    h(Route, { path: "printify/imported", element: h(DropshippingImportedProducts) }),
    h(Route, { path: "printify/orders", element: h(SellerPrintifyOrders) }),
    h(Route, { path: "printify/errors", element: h(DropshippingApiErrors) }),
    h(Route, { path: "printify/admin", element: h(DropshippingAdmin) }),
    h(Route, { path: "printify/*", element: h(Navigate, { to: "/dropshipping/printify", replace: true }) })
  )
);

const PrintifyApp = ({ baseUrl, token, translate, roleName }) => h(PrintifyProvider, { baseUrl, token, translate, roleName }, h(PrintifyRoutes));
module.exports = { PrintifyApp, PrintifyRoutes };
